import { FC, useMemo, useState } from 'react';
import { Box, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import { LoadingSpinner } from '@components';
import { useGetAllModulesQuery, useGetAllUsersQuery } from '@services/users/users';
import { User } from '@models';
import { UserManagement } from './UserManagement/UserManagement';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import { SelectUser } from './SelectUser/SelectUser';

const UsersPage: FC = () => {
  const { data: users } = useGetAllUsersQuery();
  const { data: modules } = useGetAllModulesQuery();

  const sortedUsers = useMemo(() => {
    if (users) {
      return users
        .slice()
        .sort(
          (a, b) => Number(a.isActive) - Number(b.isActive) || `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`),
        );
    }
  }, [users]);

  const [selectedUser, setSelectedUser] = useState<User>();

  const userNameText = (firstName?: string, lastName?: string, isActive?: boolean) => {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2">{`${firstName} ${lastName}`}</Typography>
        {!isActive && <FiberNewIcon color="primary" />}
      </Box>
    );
  };

  return (
    <Box overflow="hidden" height="calc(100vh - 150px)" display="flex" alignItems="center">
      {sortedUsers && modules ? (
        <Box height="90%" width="100%" display="flex" gap={2}>
          <List dense sx={{ overflowY: 'scroll', border: '1px solid lightgrey', borderRadius: '4px', minWidth: '300px' }}>
            {sortedUsers.map((user) => (
              <ListItemButton
                key={user.id}
                onClick={() => setSelectedUser(user)}
                selected={selectedUser?.email === user.email}
                data-testid="user-page-selected-user-btn"
              >
                <ListItemText primary={userNameText(user.firstName, user.lastName, user.isActive)} secondary={user.email} />
              </ListItemButton>
            ))}
          </List>
          {selectedUser ? <UserManagement user={selectedUser} modules={modules} /> : <SelectUser />}
        </Box>
      ) : (
        <LoadingSpinner isOpen={true} />
      )}
    </Box>
  );
};

export default UsersPage;
